<template>
  <div class="member-order container" v-if="orders">
    <div class="row mb-3">
      <div class="col title">訂單編號</div>
      <div class="col title d-none d-md-block">訂單日期</div>
      <div class="col title">付款狀態</div>
      <div class="col title">總金額</div>
      <div class="col title">訂單狀態</div>
    </div>
    <div class="row border-bottom border-gray pt-2 pb-2" v-for="(order, index) in orders" :key="index">
      <div class="col align-self-center d-block d-md-none">
        <div class="btn p-0 loft-text-highlight" data-bs-toggle="modal" data-bs-target="#order-modal" @click="selectedId = order.orderId">#{{ order.orderId }}</div>
        <div>{{ util.getDateStr(order.addTime * 1000) }}</div>
      </div>
      <div class="col text-center align-self-center d-none d-md-block"><span class="btn loft-text-highlight" data-bs-toggle="modal" data-bs-target="#order-modal" @click="selectedId = order.orderId">#{{ order.orderId }}</span></div>
      <div class="col text-center align-self-center d-none d-md-block">{{ util.getDateStr(order.addTime * 1000) }}</div>
      <div class="col text-center align-self-center">{{ getPayStatus(order.payStatus) }}</div>
      <div class="col text-end align-self-center">{{ util.toPriceFormat(order.goodsAmount) }}</div>
      <div class="col text-center align-self-center">{{ getOrderStatus(order.orderStatus, order.shippingStatus) }}</div>
    </div>
    <order-modal :id="selectedId"/>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import orderApi from '@/api/order.js'
import { mapGetters, mapMutations } from 'vuex'
import OrderModal from './OrderModal.vue'

export default {
  name: 'Member',
  components: {
    OrderModal
  },
  data: function () {
    return {
      orders: null,
      selectedId: null
    }
  },
  computed: {
    ...mapGetters([
      'authId'
    ]),
    util: function () {
      return util
    }
  },
  mounted: function () {
    this.apiGetOrders()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetOrders: function () {
      var self = this
      orderApi.getOrders(this.authId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.orders = rspData
      })
    },
    getOrderStatus: function (orderStatus, shippingStatus) {
      var ret = ''
      switch (orderStatus) {
        case constant.ORDER_STATUS.NOT_CONFIRM:
          ret = '未確認'
          break
        case constant.ORDER_STATUS.CONFIRMED:
          ret = '已確認'
          break
        case constant.ORDER_STATUS.CANCELED:
          ret = '取消'
          break
        case constant.ORDER_STATUS.INVALID:
          ret = '無效'
          break
        case constant.ORDER_STATUS.RETURN:
          ret = '退貨'
          break
        default:
          break
      }
      return ret
    },
    getShippingStatus: function (status) {
      var ret = ''
      switch (status) {
        case constant.SHIPPING_STATUS.NOT_SHIP:
          ret = '未發貨'
          break
        case constant.SHIPPING_STATUS.SHIPPED:
          ret = '已發貨'
          break
        case constant.SHIPPING_STATUS.DELIVERED:
          ret = '收貨確認'
          break
        case constant.SHIPPING_STATUS.DISTRIBUTING:
          ret = '配貨中'
          break
        default:
          break
      }
      return ret
    },
    getPayStatus: function (status) {
      var ret = ''
      switch (status) {
        case constant.PAY_STATUS.NOT_PAY:
          ret = '未付款'
          break
        case constant.PAY_STATUS.PAYING:
          ret = '付款中'
          break
        case constant.PAY_STATUS.PAYED:
          ret = '已付款'
          break
        case constant.PAY_STATUS.DEPOSIT:
          ret = '已付訂金'
          break
        default:
          break
      }
      return ret
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
  align-self: center;
}
.col.title {
  font-weight: 400;
}
.border-gray {
  border-color: #ededed;
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 1rem;
  }
}
</style>
